import React from "react";
import trashIcon from "../../assets/TrashIcon.svg";
import { SecondaryButton } from "../form/secondary-button";
import { PrimaryButton } from "../form/primary-button";

const DeleteUserBottomSheetContent = ({ model, onCancel, onDelete }) => (
  <>
    <div className="flex flex-col items-center justify-center text-black">
      <span className="text-pepper text-2xl  mb-3 text-center font-headings-primary">
        Are you sure you want to delete {model?.FirstName || ""} {model?.LastName || ""}
      </span>
      <span className="text-pepper text-center mb-6 font-body-primary ">
        This will permanently delete the user.
      </span>
    </div>
    <div className="flex justify-between items-center mt-2 gap-5 px-4">
      <SecondaryButton
        type="button"
        onClick={onCancel}
        className="w-[48%] !bg-white !text-pepper !border !border-pepper hover:bg-gray-100"
      >
        Cancel
      </SecondaryButton>
      <PrimaryButton
        type="button"
        onClick={onDelete}
        className="w-[48%] bg-black border border-black hover:bg-red-700"
      >
        Delete
      </PrimaryButton>
    </div>
  </>
);

export default DeleteUserBottomSheetContent;
